import React from 'react';
import { TbAlertCircle, TbBottleFilled, TbBottleOff, TbUser } from 'react-icons/tb';

import { RestaurantResponse } from '@/api/lib/restaurant';

import deliverooLogo from '../../../assets/images/deliveroo.png';
import justEatlogo from '../../../assets/images/just-eat.png';
import customDeliveryLogo from '../../../assets/images/other-delivery.png';
import uberEatlogo from '../../../assets/images/uber-eat.png';
import { ValidationStatusHistory } from '../ValidationStatusHistory';
import { DeliveryLinkButton } from '@/components/molecules/DeliveryLinkButton';
import { DefaultHTMLSwornDeclaration } from '../DefaultHTMLSwornDeclaration';
import OpenableImage from '@/components/molecules/OpenableImage/OpenableImage';

interface SeeRestaurantPendingProps {
  restaurantData: RestaurantResponse;
}

export const SeeRestaurantPending = ({ restaurantData }: SeeRestaurantPendingProps) => {
  const certificateUrl =
    restaurantData.certificate?.sizes.originalResolution?.url ||
    restaurantData.certificate?.sizes.standardResolution?.url ||
    restaurantData.certificate?.sizes.lowResolution?.url ||
    restaurantData.certificate?.sizes.thumbnail?.url;

  const isItByVisitor = restaurantData.validationStatusHistory[0]?.authorRole === 'visitor';

  console.log('restaurantData', restaurantData.emailProposal);

  return (
    <div className="divide-y xl:divide-y-0 divide-gray-200 xl:divide-x xl:grid grid-cols-10 w-full">
      <div className="flex flex-col pb-5 xl:pr-10 col-span-5">
        <div className="px-4 sm:px-0">
          <h3 className="text-lg font-semibold leading-7 text-gray-900">Informations saisies par le {isItByVisitor ? 'visiteur' : 'restaurateur'}</h3>
        </div>
        <div className="mt-6">
          <dl className="grid grid-cols-1 sm:grid-cols-2">
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Nom du restaurant</dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.name}</dd>
            </div>
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Adresse du restaurant</dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.formattedAddress}</dd>
            </div>
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-2 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Spécialités du restaurant</dt>
              <dd className="mt-1 sm:mt-2 gap-2 flex flex-wrap">
                {restaurantData.tags.map((tag) => (
                  <span key={tag.id} className="inline-flex items-center px-3 py-0.5 text-sm leading-6 rounded-full bg-primary text-white">
                    {tag.name}
                  </span>
                ))}
              </dd>
            </div>
            {!isItByVisitor && (
              <>
                <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">Prénom</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.firstNameOwner}</dd>
                </div>
                <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">Nom</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.lastNameOwner}</dd>
                </div>
                <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">E-mail du restaurateur</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.emailOwner}</dd>
                </div>
                <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">Téléphone du restaurateur</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{restaurantData.phoneNumberOwner}</dd>
                </div>
              </>
            )}
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Alcool dans l'établissement</dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-6 flex items-center gap-2">
                {restaurantData.alcohol ? (
                  <>
                    <TbBottleFilled size={30} />
                    <p>Avec alcool</p>
                  </>
                ) : (
                  <>
                    <TbBottleOff size={30} />
                    <p>Sans alcool</p>
                  </>
                )}
              </dd>
            </div>
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Liens de livraison</dt>
              <dd className="mt-1 grid grid-cols-4 sm:mt-2">
                <DeliveryLinkButton buttonLogo={uberEatlogo} buttonName="UberEat" href={restaurantData.delivery?.uberEats} />
                <DeliveryLinkButton buttonLogo={deliverooLogo} buttonName="Deliveroo" href={restaurantData.delivery?.deliveroo} />
                <DeliveryLinkButton buttonLogo={justEatlogo} buttonName="JustEat" href={restaurantData.delivery?.justEat} />
                <DeliveryLinkButton buttonLogo={customDeliveryLogo} buttonName="Autre" href={restaurantData.delivery?.customDeliveryLink} />
              </dd>
            </div>
            <div className="border-t border-gray-100 px-4 py-6 sm:col-span-2 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">Photos récupérées de Google Maps</dt>
              <p className="text-xs text-primary mt-3 ml-3.5">Image de couverture</p>
              <div className=" grid grid-cols-4 gap-y-3 gap-x-5 mt-2">
                {restaurantData.mainPictureUrl && (
                  <OpenableImage
                    picture={restaurantData.mainPictureUrl}
                    width={200}
                    height={200}
                    className="h-32 w-full rounded-lg object-cover ring-4 border ring-primary"
                  />
                )}
                {restaurantData.pictures &&
                  restaurantData.pictures
                    .splice(1, 7)
                    .map((picture, index) => (
                      <OpenableImage
                        key={index}
                        picture={picture.sizes.standardResolution?.url}
                        height={160}
                        width={208}
                        className="h-32 w-full border rounded-lg object-cover"
                      />
                    ))}
              </div>
            </div>
          </dl>
        </div>
      </div>
      <section className="col-span-5 pt-5 xl:pl-10 space-y-10 divide-y">
        <div>
          {!isItByVisitor ? (
            <>
              <p className="text-lg text-center font-semibold text-slate-700">Déclaration sur l'honneur du restaurateur</p>
              <div className="flex gap-5 flex-wrap mt-8 text-black text-center">
                {restaurantData.digitalCertificate ? (
                  <DefaultHTMLSwornDeclaration
                    firstName={restaurantData.digitalCertificate?.firstName || ''}
                    lastName={restaurantData.digitalCertificate?.lastName || ''}
                    restaurantName={restaurantData.digitalCertificate?.restaurantName || ''}
                    address={restaurantData.digitalCertificate?.address || ''}
                    date={restaurantData.digitalCertificate?.date || new Date().toISOString()}
                    suppliers={restaurantData.digitalCertificate?.suppliers || []}
                    company={restaurantData.digitalCertificate?.company || ''}
                  />
                ) : certificateUrl ? (
                  <iframe src={certificateUrl} title="certificat" className="h-[650px] w-full" />
                ) : (
                  <div className="border p-4 rounded-xl w-full">
                    <p className="text-lg">
                      Aucun certificat <i>(digital/sur papier)</i> disponible
                    </p>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="border p-4 rounded-xl w-full flex items-center gap-1 justify-center text-lg text-black">
              <TbAlertCircle size={24} />
              <TbUser size={24} />
              <p className="font-bold">Demande d'ajout réalisée par un visiteur</p>
              <p className="font-bold">: {restaurantData.emailProposal}</p>
            </div>
          )}
        </div>
        <div className="py-5">
          <p className="text-lg text-center font-semibold text-slate-700">Historique de la fiche</p>
          <div className="flex gap-5 flex-wrap mt-4 text-black text-center border p-2 rounded-lg">
            {restaurantData.validationStatusHistory.length > 0 ? (
              <div className="bg-white w-full">
                <ValidationStatusHistory validationStatusHistory={restaurantData.validationStatusHistory} />
              </div>
            ) : (
              <div className="border p-4 rounded-xl w-full">
                <p className="text-lg">Aucun historique disponible</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};
